<app-source [item]="item.payload || item"
            [enableTooltip]="true"
            [enableCategory]="showCategory"
            [enableHelpText]="true"
            class="full-height"></app-source>
